import { lazy } from "react";

/** Route-level code splitting for heavy app areas (audit FRONT-009). */

export const LazyAgentDashboard = lazy(
  () => import("../components/AgentPages/AgentDashboard/AgentDashboard")
);

export const LazyDashboardShell = lazy(
  () => import("../components/HomeDashboard/DashboardShell")
);

export const LazyHomeDashboard = lazy(
  () => import("../components/HomeDashboard/HomeDashboard")
);

export const LazyMyLeads = lazy(
  () => import("../components/AgentPages/MyLeads/MyLeads")
);

export const LazyOverviewPage = lazy(
  () => import("../components/OverviewPage/OverviewPage")
);

export const LazyLeadDetailsPage = lazy(
  () => import("../components/AgentPages/LeadDetailsPage/LeadDetailsPage")
);

export const LazyConfigurationRoutes = lazy(
  () => import("../Routes/configurationRoutes/ConfigurationRoutes")
);

export const LazySPOCTasksPage = lazy(
  () => import("../components/SPOCPages/TasksPage").then((m) => ({
    default: m.SPOCTasksPage,
  }))
);

export const LazySPOCTaskDetailPage = lazy(
  () => import("../components/SPOCPages/TasksPage").then((m) => ({
    default: m.SPOCTaskDetailPage,
  }))
);

export const LazyOpportunityRedirect = lazy(
  () => import("../components/common/OpportunityRedirect/OpportunityRedirect")
);
